import React, { Component } from "react";
import PropTypes from "prop-types";
import api from "../../../services/api";

import * as MoneyFormater from "../../../utils/MoneyFormater";
import * as DateFormater from "../../../utils/DateFormater";
import CurrencyField from "../../../components/CurrencyField";
import NotaFiscalCad from "../../../components/Acordo/NotaFiscalCad";
import * as Permissions from "../../../services/permissions";
import {
  Button,
  Icon,
  Modal,
  notification,
  Tag,
  Checkbox,
  Popconfirm
} from "antd";
import { FaExchangeAlt } from "react-icons/fa";

export default class ParcelaRow extends Component {
  state = {
    loading: false,
    parcelaSelected: false,
    parcelaValorPago: 0,
    parcelaDataPagamento: "",
    parcelaData: {},
    notafiscalVisible: false,
    editMode: false // Editando o valor recebido/data pgto
  };

  componentDidMount() {
    /**
     * Passa as informações das propriedades para o estado.
     */
    this.setState(
      {
        parcelaValorPago: this.props.parcelaData.valor_pago,
        parcelaDataPagamento:
          this.props.parcelaData.data_pagamento != null
            ? this.props.parcelaData.data_pagamento
            : "",
        parcelaData: this.props.parcelaData
      },
      () => {
        const allSelected = this.props.allSelected;
        const parcelaStatusList = this.props.parcelaStatus;

        /**
         * O id das parcelas selecionadas são salvas em um array,
         * caso o id da parcela esteja nesse array, então ela foi
         * selecionada pelo usuáro.
         */
        const parcelaSelected =
          parcelaStatusList[`${this.state.parcelaData.id}-id`];

        // Indica se essa parcela está selecionada ou não
        if (parcelaSelected != undefined) {
          this.setState({
            parcelaSelected: parcelaSelected
          });
        } else {
          this.setState({
            parcelaSelected: allSelected
          });
        }
      }
    );
  }

  /**
   * Caso o componente receba novas propriedades,
   * ele faz a verificação se o usuário selecionou a parcela,
   * ou desmarcou.
   */
  UNSAFE_componentWillReceiveProps(props) {
    const allSelected = props.allSelected;
    const parcelaStatusList = props.parcelaStatus;

    const parcelaSelected =
      parcelaStatusList[`${this.state.parcelaData.id}-id`];

    if (parcelaSelected != undefined) {
      this.setState({
        parcelaSelected: parcelaSelected
      });
    } else {
      this.setState({
        parcelaSelected: allSelected
      });
    }
  }

  translateParcelaStatus = stats => {
    switch (String(stats).toLocaleLowerCase()) {
      case "1":
        return "Pago";
      case "2":
        return "Cancelado";
      case "0":
        return "Pendente";
    }

    return null;
  };

  /**
   * Retorna o botão de acordo com o status
   * de pagamento da parcela.
   */
  getPayButton = () => {
    const status = String(
      this.state.parcelaData.status_parcela
    ).toLocaleLowerCase();

    if (this.state.editMode) {
      // Confirm buttons
      return (
        <div>
          <Button
            size="small"
            className="btn btn-green"
            onClick={this.handleReceber}
            loading={this.state.loading}
          >
            {this.state.loading ? (
              <Icon style={{ color: "white" }} type={"loading"} />
            ) : (
                <Icon style={{ color: "white" }} type={"check"} />
              )}
          </Button>
          &nbsp;&nbsp;
          <Button size="small" type="danger" onClick={this.handleEditChange}>
            <Icon type="close" />
          </Button>
        </div>
      );
    }

    switch (status) {
      case "1":
        return (
          <Button
            className="btn-green btn-green-ghost"
            ghost
            size="small"
            onClick={this.handleRecebidoClick}
            disabled={!Permissions.has("acordo.parcela_receber")}
          >
            <b>RECEBIDO</b>
          </Button>
        );
      case "2":
        return (
          <Button type="danger" disabled ghost size="small">
            <b>CANCELADO</b>
          </Button>
        );
      case "0":
        return (
          <Button
            type="primary"
            size="small"
            ghost
            onClick={this.handleEditChange}
            disabled={!Permissions.has("acordo.parcela_receber")}
          >
            <b>RECEBER</b>
          </Button>
        );
    }
  };

  /**
   * Retorna o botão de conciliação com o status
   * de conciliação.
   */
  getConciliarButton = () => {
    // Verifica se essa parcela possui nota fiscal
    if (this.state.parcelaData.notafiscal != null) {
      // Pega o status da nota fiscal
      const status_nf = this.state.parcelaData.notafiscal.status;

      switch (String(status_nf).toLocaleLowerCase()) {
        case "2":
          return (
            <Button
              className="btn btn-green"
              size="small"
              style={{ color: "white" }}
              title="Conciliar nota fiscal"
              onClick={this.handleConciliar}
              disabled={!Permissions.has("acordo.notafiscal_edit")}
            >
              <Icon component={FaExchangeAlt} />
            </Button>
          );
        case "1":
          return (
            <Button
              type="danger"
              onClick={this.handleConciliar}
              size="small"
              title="Desconciliar nota fiscal"
              disabled={!Permissions.has("acordo.notafiscal_edit")}
            >
              <Icon component={FaExchangeAlt} />
            </Button>
          );
      }
    } else {
      return (
        <Button type="primary" size="small" disabled={true}>
          <Icon component={FaExchangeAlt} />
        </Button>
      );
    }
  };

  /**
   * Retorna o campo de data do pagamento
   */
  getDataPagtoField = () => {
    return (
      <input
        className="ant-input"
        type="date"
        onChange={this.handleDataPgtoChange}
        value={this.state.parcelaDataPagamento}
        disabled={!this.state.editMode}
      />
    );
  };

  /**
   * Retorna o campo do valor do pagamento da parcela
   */
  getPagoField = () => {
    return (
      <CurrencyField
        className="ant-input"
        name={this.props.parcelaData.id + "-parc"}
        id={this.props.parcelaData.id}
        value={this.state.parcelaValorPago}
        innitialValue={
          this.state.parcelaData.valor_pago != null
            ? this.state.parcelaData.valor_pago
            : 0
        }
        onChangeEvent={this.handleValorPagoFieldChange}
        disabled={!this.state.editMode}
      />
    );
  };

  /** Retorna o status e o número da nota (Component) */
  getNotaFiscalInfos = () => {
    const notafiscal = this.state.parcelaData.notafiscal;

    // Caso a parcela possua nota fiscal
    if (notafiscal !== null && notafiscal !== undefined) {
      const numero_nf = notafiscal.numero_nf;
      const status = String(notafiscal.status);

      let vTag = null;

      switch (status) {
        case "1":
          vTag = <Tag color="green">Conciliado</Tag>;
          break;
        case "2":
          vTag = <Tag color="red">Não conciliado</Tag>;
          break;
      }

      return (
        <div
          style={{
            textAlign: "center"
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              marginBottom: "3px"
            }}
          >
            {numero_nf}&nbsp;
            <Popconfirm
              title="Deseja realmente deletar essa nota?"
              onConfirm={this.handleDeleteNf}
              okText="Confirmar"
              cancelText="Cancelar"
            >
              <Icon
                className="delete-icon"
                type="delete"
                title="Excluir nota fiscal"
              />
            </Popconfirm>
          </div>
          <div>{vTag}</div>
        </div>
      );
    } else {
      // Caso não possua, retorna um botão para cadastrar uma nota
      return (
        <div>
          <Button
            className="btn btn-green"
            size="small"
            title="Adicionar nota fiscal"
            /**
             * Caso a parcela não esteja paga, o botão
             * para cadastrar nota na parcela fica desabilitado.
             */
            disabled={this.state.parcelaData.status_parcela !== "1"}
            onClick={() => this.setState({ notafiscalVisible: true })}
          >
            <Icon type="plus" style={{ color: "white" }} />
          </Button>
          {/**
           * Quando o usuário clicar no botão para cadastro da nota fiscal,
           * o estado desse componente é atualizado setando o `notafiscalVisible`
           * para true, assim aparecendo o modal de cadastro para o usuário.
           */}
          <NotaFiscalCad
            visible={this.state.notafiscalVisible}
            parcela_id={this.state.parcelaData.id}
            updateFunction={this.updateNotaFiscalData}
          />
        </div>
      );
    }
  };

  /**
   * Retorna a data de conciliação da nota fiscal
   * no formato 00/00/0000
   */
  getNfConciliacaoData = () => {
    const notafiscal = this.state.parcelaData.notafiscal;

    if (notafiscal != null && notafiscal != undefined) {
      return DateFormater.format(notafiscal.data_conciliacao);
    }

    return null;
  };

  /**
   * Caso a nota sofra atualização no back-end, essa função
   * é chamada passando os novos dados da nota para serem atualizados
   * no estado e consequentemente na tela do usuário.
   * @param {Object} data - Dados atualizados da nota fiscal
   */
  updateNotaFiscalData = data => {
    if (this.state.parcelaData != null && this.state.parcelaData != undefined) {
      this.setState({
        parcelaData: {
          ...this.state.parcelaData,
          notafiscal: data
        }
      });
    }
  };

  /**
   * Quando o campo de data de pagamento é alterado,
   * é setado o valor do campo no estado.
   */
  handleDataPgtoChange = event => {
    const value = event.target.value;

    this.setState({
      parcelaDataPagamento: value
    });
  };

  /**
   * Ativa os campos de valor pago / data pagamento
   * quando o usuário clica no botão "receber"
   */
  handleEditChange = () => {
    if (this.state.editMode === false) {
      this.setState({
        editMode: !this.state.editMode,
        parcelaValorPago: this.state.parcelaData.valor_parcela,
        parcelaDataPagamento: DateFormater.formatReverse(
          new Date().toLocaleDateString()
        )
      });
    } else {
      this.setState({
        editMode: !this.state.editMode,
        parcelaValorPago: 0,
        parcelaDataPagamento: ""
      });
    }
  };

  handleValorPagoFieldChange = value => {
    this.setState({
      parcelaValorPago: value
    });
  };

  /**
   * Deleta a nota fiscal relacionada
   * a parcela.
   */
  handleDeleteNf = async () => {
    await api
      .delete(
        `/notafiscal/${this.state.parcelaData.id}/${this.state.parcelaData.notafiscal.numero_nf}/delete/`
      )
      .then(() => {
        notification.success({
          message: "Nota fiscal excluída."
        });

        this.updateNotaFiscalData(null);
      })
      .catch(() => {
        notification.error({
          message: "Ocorreu um problema ao tentar excluir essa nota."
        });
      });
  };

  handleRecebidoClick = () => {
    // Despagar a parcela
    const modal = Modal.confirm();

    modal.update({
      title: "Despagar parcela",
      content: "Deseja cancelar o pagamento dessa parcela?",
      onOk: this.handleDespagar,
      onCancel: () => modal.destroy(),
      okText: "Confirmar",
      cancelText: "Cancelar"
    });
  };

  handleConciliar = async () => {
    // Conciliar / Desconciliar nota fiscal
    const status = this.state.parcelaData.notafiscal.status;
    const numero_nf = this.state.parcelaData.notafiscal.numero_nf;

    switch (status) {
      case "2":
        // Conciliar
        await api
          .put(`/notafiscal/${numero_nf}/update/`, {
            status: "1",
            data_conciliacao: DateFormater.formatReverse(
              new Date().toLocaleDateString()
            )
          })
          .then(response => {
            notification.success({
              message: "Nota fiscal conciliada."
            });

            this.updateNotaFiscalData(response.data);
          })
          .catch(() => {
            notification.error({
              message: "Ocorreu um erro ao tentar conciliar essa nota."
            });
          });
        break;
      case "1":
        // Desconciliar
        await api
          .put(`/notafiscal/${numero_nf}/update/`, {
            status: "2",
            data_conciliacao: null
          })
          .then(response => {
            notification.success({
              message: "Nota fiscal desconciliada."
            });

            this.updateNotaFiscalData(response.data);
          })
          .catch(() => {
            notification.error({
              message: "Ocorreu um erro ao tentar desconciliar essa nota."
            });
          });
        break;
    }
  };

  /**
   * Recebe a parcela
   */
  handleReceber = async () => {
    const valor = this.state.parcelaValorPago;
    const data = this.state.parcelaDataPagamento;

    if (valor < 1) {
      Modal.error({
        title: "Error",
        content: "Valor inválido."
      });
      return;
    }

    if (data == null || data == "" || data.length < 1) {
      Modal.error({
        title: "Error",
        content: "Data de pagamento inválida."
      });
      return;
    }

    this.setState({
      loading: true
    });

    await api
      .put(`/parcela/${this.state.parcelaData.id}/`, {
        status_parcela: "1", // Recebido
        valor_pago: valor,
        data_pagamento: data
      })
      .then(response => {
        const newdata = response.data;

        notification.success({
          message: "Parcela recebida."
        });

        this.setState({
          parcelaData: newdata
        });
      })
      .catch(err => {
        //console.log(err);

        if (err.response) {
          if (err.response.status == 403) {
            Modal.error({
              title: "Error",
              content: "Sem permissão."
            });
            return;
          }
        }
        Modal.error({
          title: "Error",
          content: "Não foi possível atualizar a parcela."
        });
      });

    this.setState({
      loading: false,
      editMode: false
    });
  };

  /**
   * Despaga a parcela
   */
  handleDespagar = async () => {
    await api
      .put(`/parcela/${this.state.parcelaData.id}/`, {
        status_parcela: "0",
        data_pagamento: null,
        valor_pago: null
      })
      .then(response => {
        const newdata = response.data;

        notification.success({
          message: "Pagamento da parcela atualizado."
        });

        this.setState({
          parcelaData: newdata,
          parcelaValorPago: 0,
          parcelaDataPagamento: ""
        });
      })
      .catch(err => {
        //console.log(err);

        if (err.response) {
          if (err.response.status == 403) {
            Modal.error({
              title: "Error",
              content: "Sem permissão."
            });
            return;
          }
        }
        Modal.error({
          title: "Error",
          content: "Não foi possível atualizar a parcela."
        });
      });
  };

  handleSelectChange = event => {
    const value = event.target.checked;

    this.props.handleParcelaSelect(value, this.state.parcelaData.id);
  };

  render() {
    return (
      <tr>
        <td>
          <Checkbox
            onChange={this.handleSelectChange}
            checked={this.state.parcelaSelected}
          />
        </td>
        <td>{this.state.parcelaData.pasta}</td>
        <td>{this.getNotaFiscalInfos()}</td>
        <td>{this.getNfConciliacaoData()}</td>
        <td>R$ {MoneyFormater.format(this.state.parcelaData.valor_parcela)}</td>
        <td className="min-td">{this.getPagoField()}</td>
        <td className="min-td">{this.getDataPagtoField()}</td>
        <td>{DateFormater.format(this.state.parcelaData.data_vencimento)}</td>
        <td>{this.state.parcelaData.carteira}</td>
        <td>R$ {MoneyFormater.format(this.state.parcelaData.honorarios)}</td>
        <td>
          {this.translateParcelaStatus(this.state.parcelaData.status_parcela)}
        </td>
        <td className="min-td">
          <div style={{ display: "flex", alignItems: "center" }}>
            {this.getPayButton()}&nbsp;{this.getConciliarButton()}
          </div>
        </td>
      </tr>
    );
  }
}
/** Propriedades que esse componente recebe */
ParcelaRow.propTypes = {
  parcelaData: PropTypes.object
};



// WEBPACK FOOTER //
// ./src/pages/Parcelas/ParcelaRow/index.js